import { ChangeDetectorRef, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpContext } from '@angular/common/http';

import { from, mergeMap, Observable, retryWhen, switchMap } from 'rxjs';
import { retryStrategy } from '../api-loaders';
import { environment } from '../../../environments/environment';

@Injectable()
export class AdminToolHeadersHttpInterceptor implements HttpInterceptor {

  constructor() {

  }
  intercept(request: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

    //https://github.com/okta/okta-auth-js/pull/128

    let requestClone: HttpRequest<any>;

    //only set the auth headers if they were not manually set


    requestClone = request.clone({
      withCredentials:true
    });

    return next.handle(requestClone);
    

    //return from(this.oktaService.getAccessTokenPromise())
    //    .pipe(
    //        switchMap(accessToken => {
    //        let headers = request.headers;
    //        if (accessToken) {
    //            headers = headers.set('authorization', accessToken.tokenType + ' ' + accessToken.accessToken);
    //        }
    //      const requestClone = request.clone({
    //        headers
    //      });
    //      return next.handle(requestClone);
    //    })
    //  );

  }

}
